





import Vue from 'vue'

export default Vue.extend({
  name: 'TutorialIndicatorDot',

  props: {
    index: {
      type: Number,
      required: true,
    },
    currentIndex: {
      type: Number,
      required: true,
    },
  },

  computed: {
    isActive (): boolean {
      return this.index === this.currentIndex
    },
  },

  methods: {
    /**
     * スライド
     */
    slideTo () {
      this.$emit('slideTo', this.index)
    },
  },
})
